export default {
  "sending_service.columns.sent_at": "Sent",
  "sending_service.columns.type": "Type",
  "sending_service.columns.document_number": "Number",
  "sending_service.columns.method": "Method",
  "sending_service.columns.status": "Status",
  "sending_service.columns.recipient": "Recipient",
  "sending_service.columns.recipient_name": "Recipient Name",
  "sending_service.columns.subject": "Subject",
  "sending_service.columns.sender": "Sender",
  "sending_service.columns.error": "Original error details",
  "sending_service.columns.message_id": "Message ID",
  "sending_service.document_types.invoice": "Invoice",
  "sending_service.document_types.report": "Report",
  "sending_service.document_types.notification": "Notification",
  "sending_service.methods.email": "Email",
  "sending_service.methods.einvoice": "Consumer / business e-invoice",
  "sending_service.methods.unknown": "Not recorded",
  "sending_service.methods.letter": "Letter",
  "sending_service.statuses.in_queue": "In Queue",
  "sending_service.statuses.sent": "Sent",
  "sending_service.statuses.processed": "Processed",
  "sending_service.statuses.deferred": "Deferred",
  "sending_service.statuses.delivered": "Delivered",
  "sending_service.statuses.bounced": "Bounced",
  "sending_service.statuses.blocked": "Blocked",
  "sending_service.statuses.dropped": "Dropped",
  "sending_service.statuses.spam": "Spam",
  "sending_service.statuses.failed": "Failed",
  "sending_service.statuses.uncertain": "Uncertain",
};
